import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Login from "@/views/login.vue";
import PresidentOffice from "@/views/PresidentOffice.vue";
import GroupRemuneration from "@/views/GroupRemuneration.vue";
import CentralArea from "@/views/CentralArea.vue";
import ECommerce from "@/views/ECommerce.vue";
import Success from "@/views/Success.vue";
import NoPermission from "@/views/NoPermission.vue";
import VerticalMarket from "@/views/VerticalMarket.vue";
import VerticalMarket331 from "@/views/VerticalMarket331.vue";
import VerticalMarket331peakBattle from "@/views/VerticalMarket331peakBattle.vue";
import VerticalMarket2026wmbt from "@/views/VerticalMarket2026wmbt.vue";
import bjNumberCard from "@/views/bjNumberCard.vue";
import BusinessHallBJ from "@/views/BusinessHallBJ.vue";
import Call from "@/views/Call.vue";
import CallMarketing from "@/views/CallMarketing.vue";
import CallOperator from "@/views/CallOperator.vue";
import CallMonthly from "@/views/CallMonthly.vue";
import BusinessHallBJ1 from "@/views/BusinessHallBJ1.vue";
import gantt from "@/views/gantt.vue";
import Offline from "@/views/Offline.vue";
import OfflineArea from "@/views/OfflineArea.vue";
import CentralAreaRemunerationSum from "@/views/CentralAreaRemunerationSum.vue";
import CentralAreaRemunerationBP from "@/views/CentralAreaRemunerationBP.vue";
import CentralAreaRemuneration from "@/views/CentralAreaRemuneration.vue";
import BusinessHallHB from "@/views/BusinessHallHB.vue";
import RemunerationDetail from "@/views/RemunerationDetail.vue";
import BusinessHallBJMonthlyMbdc from "@/views/BusinessHallBJlMonthlyMbdc.vue";
import BusinessHallBJMbdc from "@/views/BusinessHallBJMbdc.vue";
import schedulingTableCY from "@/views/schedulingTableCY.vue";
import newMediaTwo from "@/views/newMediaTwo.vue";
import broadband from "@/views/broadband.vue";
import simCard from "@/views/simCard.vue";
import development from "@/views/development.vue";
import { getAuthUrl, getUserInfo } from "@/provide/wxConfig";
import { getQueryString } from "@/utils";
import development1 from "@/views/development1.vue";
import qySalesDaily from "@/views/qySalesDaily.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "填写信息",
    },
  },
  //
  {
    path: "/broadband/:time",
    name: "broadband",
    meta: {
      title: "宽带可视化日报",
    },
    component: broadband,
  },
  {
    path: "/newMediaTwo/:time",
    name: "newMediaTwo",
    meta: {
      title: "新媒体二组可视化日报",
    },
    component: newMediaTwo,
  },
  {
    path: "/president-office/:time",
    name: "PresidentOffice",
    meta: {
      title: "集团酬金回款情况",
    },
    component: PresidentOffice,
  },
  {
    path: "/group-remuneration/:time",
    name: "GroupRemuneration",
    meta: {
      title: "集团酬金回款情况",
    },
    component: GroupRemuneration,
  },
  {
    path: "/central-area/:time/:center",
    name: "CentralArea",
    meta: {
      title: "酬金回款情况",
    },
    component: CentralArea,
  },
  {
    path: "/schedulingTableCY/:id",
    name: "schedulingTableCY",
    meta: {
      title: "产研需求排期表",
    },
    component: schedulingTableCY,
  },
  {
    path: "/e-commerce/:time",
    name: "ECommerce",
    meta: {
      title: "电商可视化日报",
    },
    component: ECommerce,
  },
  {
    path: "/business-hall-mobile-bj/:time",
    name: "BusinessHallBJ1",
    meta: {
      title: "北京营业厅日报(移动数据)",
    },
    component: BusinessHallBJ1,
  },
  {
    path: "/business-hall-bj/:time",
    name: "BusinessHallBJ",
    meta: {
      title: "北京营业厅可视化日报",
    },
    component: BusinessHallBJ,
  },
  {
    path: "/business-hall-bj-monthly-mbdc/:time",
    name: "BusinessHallBJMonthlyMbdc",
    meta: {
      title: "北京营业厅月报",
    },
    component: BusinessHallBJMonthlyMbdc,
  },
  {
    path: "/business-hall-bj-mbdc/:time",
    name: "BusinessHallBJMbdc",
    meta: {
      title: "北京营业厅日报",
    },
    component: BusinessHallBJMbdc,
  },
  {
    path: "/business-hall-hb/:time",
    name: "BusinessHallHB",
    meta: {
      title: "河北营业厅可视化日报",
    },
    component: BusinessHallHB,
  },
  {
    path: "/vertical-market/:time",
    name: "VerticalMarket",
    meta: {
      title: "大客户可视化日报",
    },
    component: VerticalMarket,
  },
  {
    path: "/vertical-market-331/:time",
    name: "VerticalMarket331",
    meta: {
      title: "大客户战斗小组日报",
    },
    component: VerticalMarket331,
  },
  {
    path: "/vertical-market-331-peak-battle/:time",
    name: "VerticalMarket331peakBattle",
    meta: {
      title: "蓝领战斗小组日报",
    },
    component: VerticalMarket331peakBattle,
  },
  {
    path: "/vertical-market-2026-wmbt/:time",
    name: "VerticalMarket2026wmbt",
    meta: {
      title: "公务通信日报",
    },
    component: VerticalMarket2026wmbt,
  },
  {
    path: "/bjNumberCard/:time",
    name: "bjNumberCard",
    meta: {
      title: "北京号卡订单日报",
    },
    component: bjNumberCard,
  },
  {
    path: "/call/:time",
    name: "Call",
    meta: {
      title: "外呼收入日报",
    },
    component: Call,
  },
  {
    path: "/call-operator/:time",
    name: "CallOperator",
    meta: {
      title: "外呼收入日报(运营商)",
    },
    component: CallOperator,
  },
  {
    path: "/call-marketing/:time",
    name: "CallMarketing",
    meta: {
      title: "外呼收入日报(营销)",
    },
    component: CallMarketing,
  },
  {
    path: "/call-monthly/:time",
    name: "CallMonthly",
    meta: {
      title: "外呼供应商收入月报",
    },
    component: CallMonthly,
  },
  {
    path: "/offline/:time",
    name: "Offline",
    meta: {
      title: "销售拜访日报",
    },
    component: Offline,
  },
  {
    path: "/simCard/:time",
    name: "simCard",
    meta: {
      title: "国际卡销量日报",
    },
    component: simCard,
  },
  // 全域销量日报
  {
    path: "/qySalesDaily/:time",
    name: "qySalesDaily",
    meta: {
      title: "全域销量日报",
    },
    component: qySalesDaily,
  },
  {
    path: "/offline-area/:area/:time",
    name: "OfflineArea",
    meta: {
      title: "销售拜访日报",
    },
    component: OfflineArea,
  },
  // 中心/区域-酬金
  {
    path: "/central-area-remuneration-sum/:time",
    name: "CentralAreaRemunerationSum",
    meta: {
      title: "中心区域酬金回款情况",
    },
    component: CentralAreaRemunerationSum,
  },
  {
    path: "/central-area-remuneration-bp/:time",
    name: "CentralAreaRemunerationBP",
    meta: {
      title: "中心区域酬金回款情况",
    },
    component: CentralAreaRemunerationBP,
  },
  {
    path: "/central-area-remuneration/:time/:center",
    name: "CentralAreaRemuneration",
    meta: {
      title: "中心区域酬金回款情况",
    },
    component: CentralAreaRemuneration,
  },
  {
    path: "/remuneration-detail/:time/:center/:userName",
    name: "RemunerationDetail",
    meta: {
      title: "酬金明细表上传情况",
    },
    component: RemunerationDetail,
  },
  {
    path: "/development/:productName/:time",
    name: "development",
    meta: {
      title: "大航海计划",
    },
    component: development1,
  },
  {
    path: "/gantt/:time",
    name: "gantt",
    meta: {
      title: "大航海计划",
    },
    component: gantt,
  },
  {
    path: "/success",
    name: "Success",
    meta: {
      title: "提交成功",
    },
    component: Success,
  },
  {
    path: "/no-permission",
    name: "NoPermission",
    meta: {
      title: "暂无权限",
    },
    component: NoPermission,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NoPermission",
    meta: {
      title: "暂无权限",
    },
    component: NoPermission,
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from) => {
  // 动态设置标题
  window.document.title = (to?.meta?.title as string | undefined) || "六律传声";
  // 校验 openid（微信授权）
  const code = getQueryString("code");
  const openid = sessionStorage.getItem("openid");
  if (openid) {
    return true;
  }
  if (!code) {
    const res = await getAuthUrl();
    if (res.success) {
      location.replace(res.data);
      return false;
    } else {
      return { name: "NoPermission" };
    }
  } else {
    const res = await getUserInfo(code);
    if (res.success) {
      sessionStorage.setItem("openid", res.data.openid);
    }
  }
  return true;
});
export default router;
